<template>
    <div class="col-md-12">
        <div class="table-responsive flex-table">
            <h4>Adhérents au programme de fidélité</h4>

            <ul class="form__group__wrapper">
                <li class="form__group__item">
                    <label>Statut</label>
                    <custom-select
                        :field="fields[0]"
                        :value="fields[0].value"
                        :field_idx="0"
                        @field-updated="debounceParams($event, updateParams)">
                    </custom-select>
                </li>
                <li class="form__group__item form__group__item--text">
                    <label>Recherche</label>
                    <search
                        :field="fields[1]"
                        :value="fields[1].value"
                        :field_idx="1"
                        @field-updated="debounceParams($event, updateParams)">
                    </search>
                </li>
                <li v-if="isUserRolesAuthorized" class="button__export">
                    <a :href="computedLinkToDownloadCsv" target="_blank" class="btn btn-success">
                        <i class="fa fa-share-square-o"></i>
                        Exporter
                    </a>
                </li>
            </ul>

            <pagination
                v-if="paginationNeeded"
                :current-page="currentPage"
                :total-pages="totalPages"
                @click="getPageOnClick($event)">
            </pagination>

            <table v-if="showTable" class="table table-hover table-condensed table-detailed search-table" id="detailedTable">
                <thead>
                    <tr>
                        <th class="small-cell">Programme de fidélité</th>
                        <th>Client</th>
                        <th class="small-cell">Date d'adhésion</th>
                        <th class="small-cell">Solde de points</th>
                        <th class="small-cell">Nombre de codes</th>
                        <th class="small-cell">Statut</th>
                        <th class="small-cell">Fiche client</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(lpsCustomer, index) in lps.data" :key="index">
                        <td>{{ lpsCustomer.program.display_name }}</td>
                        <td class="capitalize">{{ lpsCustomer.customer.name }}</td>
                        <td >{{ formatDate(lpsCustomer.created_at) }}</td>
                        <td class="text-center">{{ lpsCustomer.points_count }}</td>
                        <td class="text-center">{{ enabledPromoCodesInLps(lpsCustomer) }}</td>
                        <td class="capitalize">{{ lpsCustomer.decoded_status }}</td>
                        <td><router-link :to="'/customer/' + lpsCustomer.customer_id" class="btn btn-success">{{ 'Détails' }}</router-link></td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="text-center">
                Aucun résultat correspondant aux critères demandés.
            </div>

            <pagination
                v-if="paginationNeeded"
                :current-page="currentPage"
                :total-pages="totalPages"
                @click="getPageOnClick($event)">
            </pagination>

        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import dateFormatting from 'mixins/dateFormatting'
import user from 'mixins/user'
import cookies from 'cookiesjs'

import CustomSelect from 'components/Forms/Elements/Select'
import Search from 'components/Forms/Elements/Text'
import Pagination from 'components/Pagination'

export default {
    name: 'LpsList',

    data () {
        return {
            params: {
                statuses: [],
                search: '',
                page: '',
                with: 'customer;program;promo_codes'
            },
            fields: [
                {
                    values: [
                        {'id': 'active', 'text': 'actif'},
                        {'id': 'terminated', 'text': 'résilié'},
                        {'id': 'disabled', 'text': 'désactivé'},
                    ],
                    multiple: true,
                    placeholder: 'Tous',
                    disabled: false,
                    idx: 0,
                    required: false,
                    value: null,
                    label: "Statut",
                    type: "select"
                },
                {
                    values: [],
                    placeholder: "Nom, erp_id, représentant légal...",
                    disabled: false,
                    idx: 1,
                    required: false,
                    value: null,
                    type: "text"
                }
            ]
        }
    },

    components: {
        CustomSelect,
        Search,
        Pagination
    },

    mixins: [
        dateFormatting,
        user
    ],

    computed: {
        ...mapState('lps', ['lps']),

        showTable () {
            return _.has(this.lps, 'data') && this.lps.data.length
        },

        currentPage () {
            return this.lps.current_page - 1
        },

        totalPages () {
            return this.lps.last_page
        },

        paginationNeeded () {
            return this.lps.last_page > 1
        },

        computedLinkToDownloadCsv () {
            const params = {
                token: cookies('token')
            }

            if (this.params.statuses)
                params.statuses = this.params.statuses

            if (this.params.search)
                params.search = this.params.search

            const urlParamsForPHP = $.param(params)

            return `${__API_URL__}/loyalty_program_subscriptions/export?${urlParamsForPHP}`
        }
    },

    methods: {
        ...mapActions('lps', ['fetchLoyaltyProgramSubscribedCustomers']),

        updateParams (event) {
            if (event.type === 'text') {
                this.params.search = event.new_value
            } else if (event.new_value) {
                this.params.statuses = _.map(event.new_value, (status) => {
                    return status.value
                })
            }
            this.params.page = 1
        },
        debounceParams: _.debounce((event, updateParams) => {
            updateParams(event)
        }, 600),

        enabledPromoCodesInLps (lps) {
            let enabledPromoCodes = _.filter(lps.promo_codes, (PromoCodes) => {
                return PromoCodes.state === 'available' ? true : false
            })

            return enabledPromoCodes.length
        },

        getPageOnClick (event) {
            this.params.page = event + 1
            this.fetchLoyaltyProgramSubscribedCustomers(this.params)
        }
    },

    watch: {
        params: {
            handler () {
                this.fetchLoyaltyProgramSubscribedCustomers(this.params)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.flex-table {
    display: flex;
    flex-direction: column;
}

.form__group__wrapper {
    display: flex;
    position: relative;
}

.form__group__item--text {
    min-width: 250px;
}

.small-cell {
    width: 130px;
}

.capitalize {
    text-transform: capitalize;
}

.button__export {
    position: absolute;
    bottom: 0;
    right: 0;
}
</style>




// WEBPACK FOOTER //
// client/components/LoyaltyProgramSubscriptions/LpsList.vue